import { render, staticRenderFns } from "./sms-captcha.vue?vue&type=template&id=30471028"
import script from "./sms-captcha.vue?vue&type=script&lang=js"
export * from "./sms-captcha.vue?vue&type=script&lang=js"
import style0 from "./sms-captcha.vue?vue&type=style&index=0&id=30471028&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports